import { render, staticRenderFns } from "./DocumentHeaderControl.vue?vue&type=template&id=2d35a71e"
import script from "./DocumentHeaderControl.vue?vue&type=script&lang=js"
export * from "./DocumentHeaderControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports